import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { DiagnosticsComponent } from './components-components/DiagnosticsComponent';
import { DiagnosticsComponentProvider } from './contexts/DiagnosticsComponentContext';
import { DrugCalculatorComponent } from './components-components/DrugCalculatorComponent';
import { DrugCalculatorComponentProvider } from './contexts/DrugCalculatorComponentContext';
import {
  createTheme,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { PMSIntegrationUserProvider as AuthUserProvider } from './contexts/AuthUserContext';
import { awsConfig } from './config/aws.config';
import {
  SharedComponentsConfigurationProvider,
  SharedComponentsConfiguration,
} from '@gekkovet-oy/shared-components';

const theme = {
  spacing: 8,
  typography: {
    h4: {
      marginTop: '1em',
    },
    h5: {
      marginTop: '1em',
    },
  },
};

// resolve the current path as base path (without query string or fragments)
const currentPath = window.location.pathname;

export const ComponentsRoot = () => {
  const { component, sessionId, searchParams } = (window as any)
    .__componentsInitialData;

  // Configuration for shared components
  const sharedComponentsConfig: SharedComponentsConfiguration = {
    gekkoApiBaseUrl: awsConfig.GEKKO_API_URL || '',
    pollingIntervalMs: 3000,
    environment:
      process.env.NODE_ENV === 'production' ? 'production' : 'development',
  };

  console.log('currentPath', currentPath);
  return (
    <AuthUserProvider>
      <BrowserRouter basename="/">
        <CssBaseline />
        <ThemeProvider theme={createTheme(theme)}>
          <StyledEngineProvider>
            <SharedComponentsConfigurationProvider
              config={sharedComponentsConfig}
            >
              <LocalizationProvider dateAdapter={AdapterMoment}>
                {component === 'diagnostics' && sessionId && (
                  <DiagnosticsComponentProvider>
                    <DiagnosticsComponent
                      sessionId={sessionId}
                      searchParams={searchParams}
                      enableChat={searchParams?.get('chat') === '1'}
                    />
                  </DiagnosticsComponentProvider>
                )}
                {component === 'drug-calculator' && sessionId && (
                  <DrugCalculatorComponentProvider>
                    <DrugCalculatorComponent
                      sessionId={sessionId}
                      searchParams={searchParams}
                    />
                  </DrugCalculatorComponentProvider>
                )}
              </LocalizationProvider>
            </SharedComponentsConfigurationProvider>
          </StyledEngineProvider>
        </ThemeProvider>
      </BrowserRouter>
    </AuthUserProvider>
  );
};
